'use client'
import { createBrowserClient } from '@supabase/ssr'
import type { SupabaseClient } from '@supabase/supabase-js'

let _client: SupabaseClient | null = null

export default function supabaseClient(): SupabaseClient {
  if (_client) return _client
  // Clean up any legacy Supabase tokens that were stored as "base64-..." strings.
  // New @supabase/ssr client expects JSON, so these old values cause JSON.parse errors.
  if (typeof window !== 'undefined') {
    try {
      const ls = window.localStorage;
      Object.keys(ls)
        .filter((k) => /^sb-|^supabase/i.test(k))
        .forEach((k) => {
          const v = ls.getItem(k);
          if (v && v.startsWith('base64-')) {
            ls.removeItem(k);
          }
        });
    } catch {
      // ignore storage errors
    }
  }
  const url  = process.env.NEXT_PUBLIC_SUPABASE_URL!
  const anon = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY!
  _client = createBrowserClient(url, anon, {
    auth: {
      flowType: 'pkce',
      detectSessionInUrl: false,   // we do the exchange explicitly on /auth/callback
      persistSession: true,
      autoRefreshToken: true,
    },
  })
  return _client
}
